import React from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import {
  TimelineContainer,
  TimelineWrapper,
  TimelineDisk,
  TimelineCard,
  TimelineLink,
  TimelineTitle,
  TimelineInfo,
  TimelineRole,
  TimelineDate,
  TimelineDescription,
  TimelineTechList,
  TimelineTechItem,
} from './Timeline.styles'
import Icon from '../Icon'

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_node, children) => (
      <TimelineDescription>{children}</TimelineDescription>
    ),
  },
}

const Role = ({ role, fullWidth = false }) => {
  return (
    <TimelineCard fullWidth={fullWidth}>
      <TimelineLink href={role.companyUrl}>
        <Icon icon="globe" />
        <TimelineTitle>{role.companyName}</TimelineTitle>
      </TimelineLink>
      <TimelineInfo>
        <TimelineRole>
          <Icon icon="dot-circle" />
          {role.role}
        </TimelineRole>
        <TimelineDate>
          <Icon icon="calendar-alt" />
          {role.startDate}{' '}
          {role.isCurrent || role.endDate ? (
            <Icon icon="long-arrow-right" />
          ) : (
            ''
          )}{' '}
          {role.isCurrent ? 'Present' : role.endDate}
        </TimelineDate>
      </TimelineInfo>
      {role.details && <>{documentToReactComponents(role.details, options)}</>}
      <TimelineTechList>
        {role.techs.map((tech, i) => (
          <TimelineTechItem key={`${i + 0}`}>{tech}</TimelineTechItem>
        ))}
      </TimelineTechList>
    </TimelineCard>
  )
}

const Timeline = ({ experience }) => {
  return (
    <TimelineContainer>
      {experience.map((role) => (
        <TimelineWrapper>
          <TimelineDisk present={role.isCurrent} />
          <Role key={role.id} role={role} />
        </TimelineWrapper>
      ))}
    </TimelineContainer>
  )
}

export { Role }
export default Timeline
